<pr-input-abstract
  [isDefault]="isDefault"
  [control]="control"
  [label]="label"
  [derrors]="derrors"
  class="pr-input-date"
  [class.has-value]="highlightOnValue && hasValue"
  [class.has-focus]="highlightOnFocus && hasFocus"
  (focusin)="hasFocus = true"
  (focusout)="hasFocus = false"
  [tooltipButton]="tooltipButton"
>
  <input
    #input
    matInput
    (dateChange)="onInputChange($event)"
    [matDatepicker]="datePicker"
    placeholder="JJ/MM/AAAA"
    (focus)="control.value ? '' : datePicker.open()"
    mask="00/00/0000"
  />
  <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
  <mat-datepicker [touchUi]="mdq.matches" #datePicker></mat-datepicker>
</pr-input-abstract>
